"use strict";

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
/*
	intro : react pure render utils
	Author : chenchao
	Date : 2019-05-22
	Note : TODO 优化比较算法
*/


var _types = require("./types");

var _types2 = _interopRequireDefault(_types);

var _countObjectLevel = require("./countObjectLevel.js");

var _countObjectLevel2 = _interopRequireDefault(_countObjectLevel);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
} // WhetherEqual function is a basic util 
// would be used to judge equal between two given sources  . 
// Of course , We recommend you to use it in your REACT COMPONENT .
// You could use it to judge whether your originSource 
// and aimSource hava the same type and value .
// originSource - origin source
// aimSource - origin source
// return true and false . 
// max running time setting


var MAX_TIME_DEFINME = 2; // recursion time

var MAX_RECURSION_TIME = 4; // define for unit testing

var window = Object.assign({}, window);

var CheckEqual = function () {
  function CheckEqual() {
    _classCallCheck(this, CheckEqual);

    this.performanceFlag = true;
    this.firstTime = true;
  } // init performance


  _createClass(CheckEqual, [{
    key: "initPerformance",
    value: function initPerformance(maxTimeSencends, maxRecursionTime, performanceFlag) {
      // setting max running time secend
      this.maxTimeSencends = maxTimeSencends; // setting max recursion times

      this.maxRecursionTime = maxRecursionTime; // whether open the performanceFlag judge

      this.performanceFlag = performanceFlag; // except some key judge in * object compare *
      // this.exceptArr = exceptArr ; 
      // set start time

      this.initTime = new Date();
      return this;
    } // count running time for runEqualCheck

  }, {
    key: "countRunningTime",
    value: function countRunningTime() {
      if (!this.performanceFlag) return false; // time target limit

      if ((new Date().getTime() - this.initTime.getTime()) / 3600 > this.maxTimeSencends) {
        return false;
      } // time is ok


      return true;
    }
  }, {
    key: "runEqualCheck",
    // equal check main function
    // @aimSource - the aimed data source which you want to judge
    // @originSource - your judged origin data
    value: function runEqualCheck(aimSource, originSource) {
      // arguments error
      if (arguments.length < 2) {
        console.warn(" WhetherEqual function should offered two params .");
        return false;
      } // main types check


      var originType = (0, _types2.default)(originSource),
          aimType = (0, _types2.default)(aimSource); // time performance limit

      if (!this.countRunningTime()) return false; // type not equal

      if (originType !== aimType) return false; // simple data type check

      if (['number', 'string', 'undefined', 'boolean', "null"].indexOf(originType) >= 0) {
        return originSource === aimSource;
      } // function check


      if ("function" === originType) {
        return this.judgeFunction(aimSource, originSource);
      } // complex data type check


      if ("array" === originType) {
        return this.judgeArray(aimSource, originSource);
      }

      if ("object" === originType) {
        return this.judgeObject(aimSource, originSource);
      }
    } // function equal check

  }, {
    key: "judgeFunction",
    value: function judgeFunction(aimSource, originSource) {
      // length not equal
      var originStr = originSource.toString().replace(/\s+/g, ""),
          aimStr = originSource.toString().replace(/\s+/g, "");
      if (originStr.length !== aimStr.length) return false;
      if (originStr === aimStr) return true;
      return false;
    } // array equal check

  }, {
    key: "judgeArray",
    value: function judgeArray(aimSource, originSource) {
      // length not equal
      if (originSource.length !== aimSource.length) return false;

      if (originSource.length < aimSource.length) {
        originSource = [].concat(aimSource);
      } // recursion check


      for (var i = 0; i < originSource.length; i++) {
        // type not equal
        if ((0, _types2.default)(originSource[i]) !== (0, _types2.default)(aimSource[i])) return false;

        if (!this.runEqualCheck(originSource[i], aimSource[i])) {
          return false;
        }
      }

      return true;
    } // 

  }, {
    key: "judgeObject",
    value: function judgeObject(aimSource, originSource) {
      // performance limit
      if (this.performanceFlag && (0, _countObjectLevel2.default)(originSource) * 1 > this.maxRecursionTime * 1) return false; // length check

      if (window.JSON && window.JSON.stringify && window.JSON.stringify(originSource).trim().length !== window.JSON.stringify(aimSource).trim().length) return false; // shallow equal

      var originKeys = Object.keys(originSource),
          aimKeys = Object.keys(aimSource);
      if (originKeys.length !== aimKeys.length) return false;

      if (originKeys.length < aimKeys.length) {
        originKeys = [].concat(aimKeys);
      } // recursion check


      for (var i = 0; i < originKeys.length; i++) {
        var tempKey = originKeys[i];
        if (aimKeys.indexOf(tempKey) < 0) return false;

        if (!this.runEqualCheck(originSource[tempKey], aimSource[tempKey])) {
          return false;
        }
      }

      return true;
    }
  }]);

  return CheckEqual;
}();

; // use one object catch to imporve
// init CheckEqual

var checkEqual = new CheckEqual(); //output init

var WhetherEqual = function WhetherEqual(originSource, aimSource) {
  var performanceFlag = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var maxTimeSencends = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : MAX_TIME_DEFINME;
  var maxRecursionTime = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : MAX_RECURSION_TIME;
  checkEqual.initTime = new Date();
  return checkEqual.initPerformance(maxTimeSencends, maxRecursionTime, performanceFlag).runEqualCheck(Object.assign({}, aimSource), Object.assign({}, originSource));
};

module.exports = WhetherEqual;